export const ON_BEHALF_OF_CLIENT_INJECT_KEY = Symbol('ahOnBehalfOfClient');
